export default "__VITE_ASSET__CWT4ljVi__"